import { useEffect } from "react"
import { useState } from "react"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
import { getSkill } from "../../../redux/actions/skills"
import ReactStars from 'react-rating-stars-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';

import { addReview } from "../../../redux/actions/skills"
import Spinner from "../../../components/Spinner"

export default function CourseRating() {

    const [skill, setSkill] = useState()
    const [review, setReview] = useState('');
    const [rating, setRating] = useState(0);

    const dispatch = useDispatch()
    const user_id = useSelector(store => store?.profileDetails?.id)
    const courses_enrolled = useSelector(
        (store) => store?.userActivity?.user_enrolled_skills
    );
    const { course_slug, skill_slug } = useParams()
    const [endIdx, setEndIdx] = useState(3);

    useEffect(() => {

        dispatch(getSkill(user_id || 0, skill_slug, (successObj) => {
            setSkill(successObj)
        }))

    }, [])

    const isUserEnrolled = (course_slug, skill_slug) => {
        if (courses_enrolled?.length > 0) {
            const index = courses_enrolled.findIndex(
                (item) =>
                    item.course_slug === course_slug && item.skill_slug === skill_slug
            );
            if (index < 0) return false;
            else return true;
        } else {
            return false;
        }
    };

    const firstExample = {
        size: 30,
        value: rating,
        onChange: (newValue) => {
            setRating(newValue);
        },
    };

    const handleReviewSubmit = () => {
        dispatch(
            addReview(user_id, skill_slug, review, rating, (res) => {
                const skillObj = { ...skill };
                skillObj.reviews.push(res);
                setSkill(skillObj);
                setReview('');
                setRating(0);
            })
        );
    };
    const hasUserGivenReview = () => {
        if (rating === 0 || review === '') {
            return true;
        }

        if (skill['reviews'] && skill['reviews'].length) {
            const index = skill['reviews'].findIndex(
                (item) => item.user_id === user_id
            );
            if (index < 0) return false;
            else return true;
        } else {
            return false;
        }
    };

    return (
        skill ? <div>
            <div className="pb-4">
                {(Boolean(skill['reviews']?.length) ||
                    isUserEnrolled(course_slug, skill_slug)) && (
                        <h1 className="text-2xl md:text-2xl font-bold py-2">
                            Student Feedback
                        </h1>
                    )}
                {isUserEnrolled(course_slug, skill_slug) && (
                    <>
                        <ReactStars {...firstExample} />
                        <textarea
                            className="resize-none rounded-md  w-full  md:w-2/3 p-4  border-2 border-[#DFDFDF]"
                            rows="5"
                            placeholder="Write your review here"
                            value={review}
                            onChange={(e) => setReview(e.target.value)}
                        ></textarea>
                        <button
                            onClick={handleReviewSubmit}
                            className="block mt-2 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-teal-600 rounded shadow disabled:bg-slate-300"
                            disabled={hasUserGivenReview()}
                        >
                            Submit Review{' '}
                        </button>
                    </>
                )}
            </div>
            {Boolean(skill['reviews']?.length) &&
                skill['reviews']
                    .slice(0, Math.min(endIdx, skill['reviews']?.length))
                    .map((review, id) => (
                        <>
                            <div className="flex pb-4 w-full" key={id}>
                                <div className="mr-4">
                                    {review.feedback_user?.profile_image ? (
                                        <img
                                            className="h-20 w-20 rounded-full "
                                            src={review.feedback_user?.profile_image}
                                            alt="profile image"
                                        />
                                    ) : (
                                        <FontAwesomeIcon
                                            icon={faUserCircle}
                                            size={'lg'}
                                            className={'h-20 w-20 rounded-full'}
                                        />
                                    )}
                                </div>
                                <div className="flex flex-col w-4/5">
                                    <h2 className="text-md font-semibold">
                                        {review.feedback_user?.name}
                                    </h2>
                                    <div className="flex">
                                        <ReactStars
                                            size={16}
                                            value={review.rating}
                                            edit={false}
                                            color="white"
                                        />
                                        <span className="text-gray-700 text-sm ml-2">
                                            {new Date(review?.created_at).toLocaleDateString()}
                                        </span>
                                    </div>
                                    <p className="text-sm">{review.feedback}</p>
                                </div>
                            </div>
                            <hr className="mx-8  md:w-2/3" />
                        </>
                    ))}
            {skill['reviews']?.length >= 3 && (
                <span
                    className="underline block cursor-pointer  md:w-2/3 p-2  mr-2 my-2 text-[#129679] text-right font-semibold"
                    onClick={() => {
                        if (endIdx >= skill['reviews'].length) {
                            setEndIdx(3);
                        } else {
                            setEndIdx((prevIdx) =>
                                Math.min(prevIdx + 3, skill['reviews'].length)
                            );
                        }
                    }}
                >
                    {endIdx >= skill['reviews'].length
                        ? skill['reviews'].length === 3
                            ? ''
                            : 'Hide'
                        : 'Show More'}
                </span>
            )}
        </div> : <Spinner />
    )
}